import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	saveButton: {
		id: 'jira-option-color-picker.labels-color-picker.save-button',
		defaultMessage: 'Save ⏎',
		description: 'Save button text',
	},
});
